import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductModel,RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import {LoadRealTimeInventory ,LoadRealTimePrices, chain} from "@insite/client-framework/Store/Pages/ProductList/Handlers/LoadProductsPricingAndInventory";
import { Handler, replaceInChain ,makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";

interface Parameter {
    products?: ProductModel[];
    productInfosByProductId: SafeDictionary<ProductInfo>;
}

export interface DisplayProductsResult {}

interface Props {
    pricingLoaded: boolean;
}

type HandlerType = Handler<Parameter, Props>;

const CustomLoadRealTimePricing: HandlerType = async props => {
    const { productInfosByProductId } = props.parameter;
    
    const validProductParams = Object.values(productInfosByProductId)
        .filter((p): p is ProductInfo =>
            !!p &&
            !!p.productId &&
            p.productId.trim() !== "" &&
            !p.productId.toLowerCase().startsWith("temp-") && //  remove temp
            !p.pricing
        )
        .map(p => ({
            productId: p.productId,
            unitOfMeasure: p.unitOfMeasure || "",
            qtyOrdered: p.qtyOrdered || 1,
        }));
        
    if (validProductParams.length === 0) {
    props.pricingLoaded = true;
    return;
    }

    const loadRealTimePricingParameter: Parameters<typeof loadRealTimePricing>[0] = {
        productPriceParameters: validProductParams,

        onSuccess: realTimePricing => {
            props.dispatch({
                type: "Pages/ProductList/CompleteLoadRealTimePricing",
                realTimePricing,
            });
            props.pricingLoaded = true;
        },

        onError: () => {
            props.dispatch({
                type: "Pages/ProductList/FailedLoadRealTimePricing",
            });
            props.pricingLoaded = true;
        },

        onComplete(realTimePricingProps) {
            if (realTimePricingProps.apiResult) {
                this.onSuccess?.(realTimePricingProps.apiResult);
            } else if (realTimePricingProps.error) {
                this.onError?.(realTimePricingProps.error);
            }
        },
    };

    const settings = getSettingsCollection(props.getState());

    // SSR handling
    if (
        IS_SERVER_SIDE &&
        getIsWebCrawler() &&
        !settings.websiteSettings.includeRealTimeInventoryAndPricingForSeo
    ) {
        const awaitableLoadRealTimePricing = makeHandlerChainAwaitable<
            Parameters<typeof loadRealTimePricing>[0],
            RealTimePricingModel
        >(loadRealTimePricing);

        const realTimePricing = await awaitableLoadRealTimePricing({
            productPriceParameters: validProductParams,
        })(props.dispatch, props.getState);

        if (realTimePricing) {
            loadRealTimePricingParameter.onSuccess?.(realTimePricing);
        } else {
            loadRealTimePricingParameter.onError?.(realTimePricing);
        }
    } else {
        props.dispatch(loadRealTimePricing(loadRealTimePricingParameter));
    }

    const productSettings = settings.productSettings;

    if (productSettings.canSeePrices && productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }
};

export const CustomLoadRealTimeInventory: HandlerType = props => {
    // if (!props.parameter.products?.length ||  (getIsWebCrawler() && !getSettingsCollection(props.getState()).websiteSettings.includeRealTimeInventoryAndPricingForSeo)
    // ) {
    //     return;
    // }

    // const { productInfosByProductId } = props.parameter;
    
    // const productIds = Object.keys(productInfosByProductId).filter(o => !productInfosByProductId[o]?.inventory);
    // console.log("Loading real time inventory for product ids: ", productIds);
    // if (productIds.length === 0) {
    //     return;
    // }

    // props.dispatch(
    //     loadRealTimeInventory({
    //         productIds,
    //         onSuccess: realTimeInventory => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/CompleteLoadRealTimeInventory",
    //                 realTimeInventory,
    //             });
    //         },
    //         onError: () => {
    //             props.dispatch({
    //                 type: "Pages/ProductList/FailedLoadRealTimeInventory",
    //             });
    //         },
    //         onComplete(realTimeInventoryProps) {
    //             if (realTimeInventoryProps.apiResult) {
    //                 this.onSuccess?.(realTimeInventoryProps.apiResult);
    //             } else if (realTimeInventoryProps.error) {
    //                 this.onError?.(realTimeInventoryProps.error);
    //             }
    //         },
    //     }),
    // );
};
replaceInChain(chain, LoadRealTimePrices, CustomLoadRealTimePricing);
replaceInChain(chain, LoadRealTimeInventory, CustomLoadRealTimeInventory);
